import API from "../../axiosConfig/axiosConfig"
import axios from "axios"
import {
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  MOBILE_VERIFICATION_SUCCESS,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  SAVE_PREFERENCES_SUCCESS,
  USER_LOADED,
  TO_BE_VERIFIED_NUMBER,
  PARTNER_DETAILS_FETCHED,
  UPDATE_ADDRESS_SUCCESS,
  USER_UPDATED,
  SET_PARTNER_DETAILS,
  SECRETCODE_SUCCESS,
  MOBILE_VERIFICATION_FAILED,
  DEV__RESET,
  AUTH_REQUEST,
  AUTH_DONE,
  SAVING_ADDRESS,
} from "../types/types"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import { getFormattedAPIEndPoint } from "../../utils/urlFormations"
import history from "../../history"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
} from "../../components/Notification/Notifications"
import {
  RESEND_EMAIL_SUCCESS,
  OTP_SENT_MESSAGE,
  PARTNER_REMOVED,
} from "../../constants/notificationMsg"
import _ from "../../utils/lodashUtils"
import { FirebaseService, FIREBASE_STATE_KEYS } from "../../firebase"
import { store } from "../../store"

export const emailVerification = (
  token,
  email,
  isResendingEmail = true
) => async dispatch => {
  // Do the email verification call, overriding local storage token.

  try {
    await API.post(
      ENDPOINTS.VERIFY_EMAIL,
      { email: email },
      { Authorization: `Token ${token}` },
      true
    )
    if (isResendingEmail)
      ToastMessage({
        type: NOTIFICATION_TYPES.INFO,
        message: RESEND_EMAIL_SUCCESS,
      })
  } catch (err) {
    console.error("Verify email failed", err)
    return err.response
  }
}

const redirectTo = response => async dispatch => {
  const userData = response.user_info
  const partnerData = response["dating-info"]
  if (
    !userData.display_name ||
    (!(
      userData.phone_number_verification_status &&
      userData.signup_method === "PHONE"
    ) &&
      !(
        userData.email_verification_status && userData.signup_method == "EMAIL"
      ))
  ) {
    history.push("/contact")
  } else if (partnerData.chat_channel_sid && partnerData.chat_space_name) {
    if (userData.address && userData.address.user_address)
      history.push("/choose-restaurant")
    else history.push("/get-address")
  }
  const location = {
    pathname: "/dashboard",
    state: { fromLogin: true },
  }
  localStorage.setItem("isPathFromLogin", true)
  history.push(location)
}

// Register User by email and password
export const registerByEmail = (
  { email, password },
  isPartnerSignup
) => async dispatch => {
  const body = {
    email: email,
    password: password,
    signup_with_invite: isPartnerSignup,
  }

  try {
    dispatch({
      type: AUTH_REQUEST,
    })
    const res = await API.post(ENDPOINTS.REGISTER_EMAIL, body, {}, true)
    if (!isPartnerSignup)
      emailVerification(res.data.token, res.data.user_info.email, false)()
    // login to firebase.
    await FirebaseService.authenticateWithToken(_.get(res, "data.fb_token"))
    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    })
    dispatch({
      type: USER_LOADED,
      payload: res.data.user_info,
    })
    if (isPartnerSignup && res.data["dating-info"]) {
      dispatch({
        type: SECRETCODE_SUCCESS,
        payload: res.data["dating-info"],
      })
      FirebaseService.setUserPresence(true)
      FirebaseService.setInviteStatus("ACTIVE")
    }
    const location = {
      pathname: "/contact",
      state: { fromLogin: true },
    }
    localStorage.setItem("isPathFromLogin", true)
    history.push(location)
    dispatch({
      type: AUTH_DONE,
    })
    if (!_.get(res.data, "is_token_valid", "true")) {
      ToastMessage({
        type: NOTIFICATION_TYPES.ERROR,
        message: PARTNER_REMOVED,
      })
    }
  } catch (err) {
    dispatch({
      type: REGISTER_FAIL,
    })
    dispatch({
      type: AUTH_DONE,
    })
    return err.response
  }
}

// Login User by email and password
export const loginByEmail = (
  { email, password },
  isPartnerSignup
) => async dispatch => {
  const body = {
    email: email,
    password: password,
    login_with_invite: isPartnerSignup,
  }

  try {
    const res = await API.post(ENDPOINTS.LOGIN_EMAIL, body, {}, true)

    const datingInfo = res.data["dating-info"]
    // login to firebase.
    await FirebaseService.authenticateWithToken(_.get(res, "data.fb_token"))
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    })

    dispatch({
      type: USER_LOADED,
      payload: res.data.user_info,
    })

    if (datingInfo.id) {
      dispatch({
        type: PARTNER_DETAILS_FETCHED,
        payload: datingInfo,
      })
      dispatch({
        type: SET_PARTNER_DETAILS,
        payload: datingInfo,
      })
      await FirebaseService.setUserPresence(true)
    }
    if (isPartnerSignup && datingInfo) {
      dispatch({
        type: SECRETCODE_SUCCESS,
        payload: res.data["dating-info"],
      })
      FirebaseService.setUserPresence(true)
      FirebaseService.setInviteStatus("ACTIVE")
    }

    redirectTo(res.data)()
  } catch (err) {
    dispatch({
      type: LOGIN_FAIL,
    })
    return err.response
  }
}

// Saving preferences About you info
export const savePreferences = (
  { displayName, lastName, dateOfBirth, pronoun, lat, long },
  userId,
  goToDashboard
) => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.SAVE_USER_DETAILS, {
    $userId: userId,
  })
  const user = _.get(store.getState(), "auth.user")
  const firebaseDefaultPath = FirebaseService.getDefaultPath()

  const body = JSON.stringify({
    display_name: displayName,
    first_name: displayName,
    last_name: lastName,
    dob: dateOfBirth,
    gender: pronoun,
    lat: lat,
    long: long,
  })

  try {
    const res = await API.put(URL, body)
    dispatch({
      type: SAVE_PREFERENCES_SUCCESS,
      payload: res.data,
    })
    FirebaseService.patch(
      res.data,
      `${firebaseDefaultPath}${user.uuid}/${FIREBASE_STATE_KEYS.USER_DETAILS}/`
    )
    if (goToDashboard) history.push("/dashboard")
  } catch (err) {
    console.error("save profile data error", err)
  }
}

// Register User by mobile
export const registerByMobile = (
  { mobile },
  isPartnerSignup
) => async dispatch => {
  const body = { phone: mobile, signup_with_invite: isPartnerSignup }
  dispatch({
    type: AUTH_REQUEST,
  })
  try {
    const res = await API.post(ENDPOINTS.REGISTER_MOBILE, body, {}, true)
    // login to firebase.
    await FirebaseService.authenticateWithToken(_.get(res, "data.fb_token"))
    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    })

    if (isPartnerSignup && res.data["dating-info"]) {
      dispatch({
        type: SECRETCODE_SUCCESS,
        payload: res.data["dating-info"],
      })
      FirebaseService.setUserPresence(true)
      FirebaseService.setInviteStatus("ACTIVE")
    }

    if (!isPartnerSignup || !_.get(res.data, "is_token_valid", "true"))
      history.push("/verify-otp")
    else {
      const location = {
        pathname: "/contact",
        state: { fromLogin: true },
      }
      history.push(location)
      localStorage.setItem("isPathFromLogin", true)
    }
    dispatch({
      type: AUTH_DONE,
    })
    if (!_.get(res.data, "is_token_valid", "true")) {
      ToastMessage({
        type: NOTIFICATION_TYPES.ERROR,
        message: PARTNER_REMOVED,
      })
    }
  } catch (err) {
    dispatch({
      type: REGISTER_FAIL,
    })
    dispatch({
      type: AUTH_DONE,
    })
    return err.response
  }
}

// Login User by Mobile
export const loginByMobile = (
  { mobile },
  isPartnerSignup
) => async dispatch => {
  const body = { phone: mobile, login_with_invite: isPartnerSignup }

  try {
    const res = await API.post(ENDPOINTS.LOGIN_MOBILE, body, {}, true)
    // login to firebase.
    await FirebaseService.authenticateWithToken(_.get(res, "data.fb_token"))
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    })
    history.push("/verify-otp")
    ToastMessage({ type: NOTIFICATION_TYPES.INFO, message: OTP_SENT_MESSAGE })
    dispatch({
      type: MOBILE_VERIFICATION_FAILED,
      payload: false,
    })
  } catch (err) {
    dispatch({
      type: LOGIN_FAIL,
    })
    return err.response
  }
}

// verifyOtp
export const verifyOtp = ({ mobile, otp }) => async dispatch => {
  const body = JSON.stringify({ phone: mobile, otp: otp })
  dispatch({
    type: MOBILE_VERIFICATION_FAILED,
    payload: false,
  })
  try {
    const res = await API.post(
      ENDPOINTS.VERIFY_OTP_SIGNUP_LOGIN,
      body,
      {},
      true
    )
    const datingInfo = res.data["dating-info"]
    // login to firebase.
    await FirebaseService.authenticateWithToken(_.get(res, "data.fb_token"))
    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    })

    dispatch({
      type: USER_LOADED,
      payload: res.data.user_info,
    })
    if (datingInfo.id) {
      dispatch({
        type: PARTNER_DETAILS_FETCHED,
        payload: res.data["dating-info"],
      })
      dispatch({
        type: SET_PARTNER_DETAILS,
        payload: res.data["dating-info"],
      })
      await FirebaseService.setUserPresence(true)
    }
    if (datingInfo.id && datingInfo.partner2_status === "ACCEPTED") {
      dispatch({
        type: SECRETCODE_SUCCESS,
        payload: res.data["dating-info"],
      })
      FirebaseService.setUserPresence(true)
      FirebaseService.setInviteStatus("ACTIVE")
    }
    redirectTo(res.data)()
  } catch (error) {
    dispatch({
      type: MOBILE_VERIFICATION_FAILED,
      payload: true,
    })
  }
}

export const verifyMobile = (
  { mobile, otp },
  setOtpField
) => async dispatch => {
  const body = JSON.stringify({ phone: mobile, otp: otp })
  dispatch({
    type: MOBILE_VERIFICATION_FAILED,
    payload: false,
  })
  try {
    const res = await API.post(
      ENDPOINTS.VERIFY_MOBILE_CONTACT_YOU,
      body,
      {},
      true
    )
    setOtpField()
    dispatch({
      type: MOBILE_VERIFICATION_SUCCESS,
      payload: res.data,
    })

    dispatch({
      type: USER_LOADED,
      payload: res.data.user_info,
    })
    if (_.get(res, "data.dating-info.id", "")) {
      dispatch({
        type: PARTNER_DETAILS_FETCHED,
        payload: res.data["dating-info"],
      })
      dispatch({
        type: SET_PARTNER_DETAILS,
        payload: res.data["dating-info"],
      })
      await FirebaseService.setUserPresence(true)
    }
  } catch (err) {
    dispatch({
      type: MOBILE_VERIFICATION_FAILED,
      payload: true,
    })
  }
}

export const sendOtpToMobile = ({ mobile }, setOtpField) => async dispatch => {
  const body = JSON.stringify({ phone: mobile })

  try {
    const res = await API.post(ENDPOINTS.SEND_OTP, body, {}, true)
    setOtpField()
    dispatch({
      type: TO_BE_VERIFIED_NUMBER,
      payload: mobile,
    })
    ToastMessage({ type: NOTIFICATION_TYPES.INFO, message: OTP_SENT_MESSAGE })
    dispatch({
      type: MOBILE_VERIFICATION_FAILED,
      payload: false,
    })
  } catch (err) {
    return err.response
  }
}

// Logout
export const logout = () => async dispatch => {
  try {
    await API.post(ENDPOINTS.LOGOUT)
    await FirebaseService.setUserPresence(false)
    await FirebaseService.AUTH.signOut()
    history.push("/register")
    dispatch({ type: LOGOUT })
    dispatch({ type: DEV__RESET })
  } catch (error) {
    console.error("LOGOUT FAILED", error)
  }
}

// Getting local address from coordinates
export async function getAddressFromCoord(latitude, longitude) {
  const url = getFormattedAPIEndPoint(
    ENDPOINTS.GET_ADDRESS_FROM_COORD_ENDPOINT,
    { $latitude: latitude, $longitude: longitude }
  )
  try {
    const res = await API.get(url)
    return res.data
  } catch (err) {
    console.error("get address from co-ordinates error", err)
  }
}

// Updating user address
export const updateAddress = (
  address,
  redirect = true,
  notifyPartner = true,
  checkCombinedOrder = true,
  isPartnerUsingSameAddress = false
) => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.UPDATE_USER_ADDRESS)
  const sameAddressUrl = getFormattedAPIEndPoint(ENDPOINTS.SAME_ADDRESS)
  const payload = {
    address: address,
  }
  if (isPartnerUsingSameAddress) {
    Object.assign(payload, { isPartnerUsingSameAddress })
  }
  const body = JSON.stringify(payload)

  try {
    const res = await API.put(URL, body)
    dispatch({
      type: UPDATE_ADDRESS_SUCCESS,
      payload: res.data,
    })
    const user = _.get(store.getState(), "auth.user")
    const partner = _.get(store.getState(), "auth.partner")
    const partnerId = _.get(partner, "uuid")
    const firebaseDefaultPath = FirebaseService.getDefaultPath()
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.USER_ADDRESS]: address,
      },
      `${firebaseDefaultPath}${user.uuid}/${
        FIREBASE_STATE_KEYS.USER_DETAILS
      }/${[FIREBASE_STATE_KEYS.ADDRESS]}`
    )
    if (isPartnerUsingSameAddress) {
      FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.USER_ADDRESS]: address,
        },
        `${firebaseDefaultPath}${partner.uuid}/${
          FIREBASE_STATE_KEYS.USER_DETAILS
        }/${[FIREBASE_STATE_KEYS.ADDRESS]}`
      )
    }
    if (notifyPartner) {
      FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.NOTIFY_ADDRESS_CHANGE]: true,
        },
        `${firebaseDefaultPath}${partner.uuid}`
      )
    }

    if (checkCombinedOrder) {
      try {
        await API.get(sameAddressUrl, {}, true)
        await FirebaseService.patch({
          [FIREBASE_STATE_KEYS.NOTIFY_ORDER_COMBINE]: partnerId,
        })
      } catch (error) {
        console.error("error while checking if same address", error)
        FirebaseService.setOrderCombined(false)
      }
    }
    if (redirect) history.push("/dashboard")
  } catch (err) {
    console.error("error while updating address", err)
  }
}
export const setSavingAddress = value => async dispatch => {
  dispatch({
    type: SAVING_ADDRESS,
    payload: value,
  })
}

//get user data
export const getUserData = userId => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.GET_USER_DATA, {
    $userId: userId,
  })

  try {
    const res = await API.get(URL, null, true)
    dispatch({
      type: USER_UPDATED,
      payload: res.data,
    })
  } catch (err) {
    console.error("error while getting user data", err)
  }
}

export const dispatchLogout = () => async dispatch => {
  dispatch({
    type: LOGOUT,
  })
}

export const fetchAddressAutoComplete = inputAddress => async dispatch => {
  const countryCode = ["us"]
  const URL = getFormattedAPIEndPoint(ENDPOINTS.GET_ADDRESS_AUTOCOMPLETE, {
    $address_input: inputAddress,
    $country_code: countryCode[0],
  })
  try {
    const res = await API.get(URL)
    return res
  } catch (err) {
    console.error("fetch address from google api error", err)
  }
}

export const verifyPasswordReset = (uuid, token) => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.VERIFY_PASSWORD_TOKEN, {
    $uuid: uuid,
    $token: token,
  })

  try {
    const res = API.get(URL, {}, true)
    return res
  } catch (error) {
    console.error("verify password reset error", error)
  }
}

export const setPassword = (uuid, password) => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.PASSWORD_RESET_URL, {
    $token: uuid,
  })
  const body = {
    password: password,
  }
  try {
    const res = API.post(URL, body)
    return res
  } catch (error) {
    console.error("set password error", error)
  }
}

export const getHelp = feedback => async dispatch => {
  const reqBody = {
    feedback: feedback,
  }

  try {
    const res = API.post(ENDPOINTS.GET_HELP, reqBody)
    return res
  } catch (error) {
    console.error("error while getting help", error)
  }
}

export const verifyToken = (email, token) => async dispatch => {
  const reqBody = {
    token: token,
    email: email,
  }
  try {
    const res = await API.post(ENDPOINTS.VERIFY_MAIL_TOKEN, reqBody)
    //log in directly if no user is logged in or if same user is logged in
    if (
      !_.get(store.getState().auth, "user.username") ||
      _.get(res.data, "user_info.username") ===
        _.get(store.getState().auth, "user.username")
    ) {
      await FirebaseService.authenticateWithToken(_.get(res, "data.fb_token"))
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      })

      dispatch({
        type: USER_LOADED,
        payload: res.data.user_info,
      })
      const location = {
        pathname: "/dashboard",
        state: { fromLogin: true },
      }
      localStorage.setItem("isPathFromLogin", true)
      history.push(location)
      dispatch({
        type: AUTH_DONE,
      })
    }
    return res
  } catch (error) {
    console.error("error while verifying token", error)
    return error.response
  }
}

export const getPresignedUrl = async () => {
  try {
    const res = await API.get(ENDPOINTS.GET_PRESIGNED_URL)
    return res.data
  } catch (error) {}
}

export const uploadPictureToS3 = (url, file) => async dispatch => {
  const options = {
    headers: {
      "Content-Type": "application/octet-stream",
    },
  }
  try {
    const res = await axios.put(url, file, options)
    return "success"
  } catch (error) {
    console.error("error while uploading pic to s3", error)
    return "error"
  }
}

export const updateImageUrlToBackend = url => async dispatch => {
  const body = {
    image_url: url,
  }
  try {
    const res = await API.post(ENDPOINTS.UPLOAD_IMAGE_SUCCESS, body)
    dispatch({
      type: SAVE_PREFERENCES_SUCCESS,
      payload: res.data,
    })
    const user = _.get(store.getState(), "auth.user")
    const firebaseDefaultPath = FirebaseService.getDefaultPath()
    FirebaseService.patch(
      res.data,
      `${firebaseDefaultPath}${user.uuid}/${FIREBASE_STATE_KEYS.USER_DETAILS}/`
    )
  } catch (error) {
    console.error("update s3 url of image to our db error", error)
  }
}
